import { TEMPLATE_VARIABLES, type VariableDefinition } from "@babackapp/variables-registry";
import useCurrentShopSuspense from "../hooks/use-current-shop-suspense";

/**
 * Group an arbitrary variable list by its `group` field into ordered entries.
 * Domain-agnostic: used by the variables picker for both tracking and return.
 */
export function groupVariables(
  variables: VariableDefinition[],
): [string, VariableDefinition[]][] {
  const grouped = variables.reduce(
    (acc, definition) => {
      (acc[definition.group] ??= []).push(definition);
      return acc;
    },
    {} as Record<string, VariableDefinition[]>,
  );
  return Object.entries(grouped);
}


export function useDefaultEditorVariables() {
  const { data: shop } = useCurrentShopSuspense();
  const shopParams = { "shop.name": shop.name };

  return TEMPLATE_VARIABLES.map((definition) => {
    if (definition.id in shopParams) {
      return {
        ...definition,
        exampleValue: shopParams[definition.id as keyof typeof shopParams],
      };
    }

    return definition;
  });
}

export function useDefaultEditorVariablesGroupped() {
  return useDefaultEditorVariables().reduce(
    (acc, definition) => {
      if (!acc[definition.group]) {
        acc[definition.group] = [];
      }
      acc[definition.group].push(definition);
      return acc;
    },
    {} as Record<string, VariableDefinition[]>,
  );
}

export function useEditorVariablesEntries() {
  return Object.entries(useDefaultEditorVariablesGroupped());
}
